export const PRINT_SETTINGS_UPDATE = 'PRINT_SETTINGS_UPDATE'
export const PRINT_SETTINGS_FETCH = 'PRINT_SETTINGS_FETCH'
